export default "__VITE_ASSET__FyWkupYU__"